// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__24FF-","modalFooterButton":"ModalNotes_modalFooterButton__3BYvQ"};